<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-form :model="editForm" :rules="rules" ref="editForm">
                  <el-row>

                    <el-col :span="12" class="item">
                      <el-form-item label="商家" required prop="businessCode">
                        <el-select v-model="editForm.businessCode" placeholder="请选择商家" style="width: 100%">
                          <el-option
                              v-for="item in arr_business"
                              :key="item.businessCode"
                              :label="item.name"
                              :value="item.businessCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="姓名" required prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入收银员姓名"></el-input>
                      </el-form-item>
                    </el-col>
                       <el-col :span="12" class="item">
                          <el-form-item label="注册账号（手机号）" required prop="phone">
                              <el-input v-model="editForm.phone"  maxlength="11" placeholder="请输入注册账号"></el-input>
                          </el-form-item>
                      </el-col>


                      <el-col :span="12" class="item">
                          <el-form-item label="状态" required prop="status">
                              <el-select v-model="editForm.status" placeholder="请选择状态" style="width:100%">
                                  <el-option
                                          v-for="item in statusValues"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                  </el-option>
                              </el-select>
                          </el-form-item>
                      </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="性别" required prop="gender">
                        <el-radio-group v-model="editForm.gender" style="width:100%">
                          <el-radio :label="0">女</el-radio>
                          <el-radio :label="1">男</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
      props:['arr_business'],
        data() {
            return {


                statusValues: [
                   {
                    value: 1, label: '正常'
                  }, {
                    value: 2, label: '禁用'
                  },
                ],


                loading: false,

                editForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                  businessCode:'',
                    name:'',
                    phone:'',
                    status:'',
                    gender:0,
                    socialWorkerCode:''
                },

                rules:{
                    phone:[
                        { required: true, message: '请输入注册账号', trigger: 'blur' },
                        {
                            pattern: /^1[3456789]\d{9}$/,
                            message: '请输入正确的手机号'
                        },
                    ],
                    password:[
                        { required: true, message: '请输入注册密码', trigger: 'blur' },
                    ],
                     name:[
                        { required: true, message: '请输入姓名', trigger: 'blur' },
                    ],
                  businessCode:[
                    { required: true, message: '请选择商家', trigger: 'blur' },
                  ],
                },
            }
        },

        methods: {
            init(row){
                this.$refs.editForm.resetFields();

                this.editForm.name=row.name
                this.editForm.phone=row.phone
                this.editForm.status=row.status
                this.editForm.gender=row.gender
                this.editForm.socialWorkerCode=row.socialWorkerCode
              this.editForm.businessCode=row.businessCode

            },

            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        this.$message({type: 'info', message: '请完善信息'});
                        return false;
                    }
                })

            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }
                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"SocialWorker/GovEditBus",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message.error(response.data.message)
                        }
                    }
                )
            },


        }
    }


</script>

<style lang="scss" scoped>

</style>
